// extracted by css-extract-rspack-plugin
export default {"cls1":"UserTooltip-cls1_Kkx","cls2":"UserTooltip-cls2_-gz UserTooltip-cls1_Kkx"};